module.exports = __webpack_public_path__ + "static/img/ent-detail-66.f5c2fda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-66.jpg
// module id = wdg3
// module chunks = 52